// @flow
import { PureComponent } from "react"

export type Props = {
  title: string,
  keywords: string,
  description: string,
}

export default class HeaderDataSideEffects extends PureComponent<Props> {
  componentDidUpdate() {
    const { title, keywords, description } = this.props

    document.title = title
    const keywordsNode = document.querySelector("meta[name=keywords]")
    if (keywordsNode) {
      keywordsNode.setAttribute("content", keywords)
    }

    const descNode = document.querySelector("meta[name=description]")
    if (descNode) {
      descNode.setAttribute("content", description)
    }
  }

  // eslint-disable-next-line lodash-fp/prefer-constant
  render() {
    return null
  }
}
